import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-violet-900 text-white" data-id="element-25">
      <div className="max-w-4xl mx-auto text-center" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-27">
          <h2 className="font-playfair text-4xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-28">
            El 22 de Abril a las 7:30 PM, Tu Negocio Tiene Página Web.
          </h2>

          <p className="text-xl md:text-2xl mb-12 font-light leading-relaxed" data-id="element-29">
            O sigues esperando "el momento perfecto" otros 6 meses. Tú eliges.
          </p>

          <motion.a href="https://sharontirado.mykajabi.com/offers/JCeY2FLo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-12 py-6 bg-white text-violet-600 text-xl font-bold rounded-xl shadow-2xl hover:shadow-3xl transition-all" whileHover={{
          scale: 1.05,
          y: -3
        }} whileTap={{
          scale: 0.98
        }} data-id="element-30">
            SÍ, QUIERO MI LUGAR
            <ArrowRightIcon className="w-6 h-6" data-id="element-31" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}